<script lang="ts">
    import { _ } from "svelte-i18n"
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"
    import RalChooser from "./RalChooser.svelte"
    import OptionsChooser from "./OptionsChooser.svelte"
    import { colorGroup1, optionsConf } from "../../config"
    import { contentOverlay, openOptionsChooserOverlay, openRalChooserOverlay } from "../../store"
    import { getProductOption, isSelectableOption } from "../../utils"
    import { onDestroy, onMount } from "svelte"
    import { langField } from "../../i18n"

    export let product: Product
    export let activeColor: RALColor = undefined
    export let activeOptions: string[] = []
    export let imageColorMismatch = false
    $: quboMatt = product.code.toString().match(/^23/) ? " matt" : ""

    const validProductOptions = product.options?.map((o) => o.option)
    activeOptions = activeOptions.filter((o) => {
        // remove invalid options for this product
        // @ts-ignore
        if (validProductOptions?.indexOf(o) === -1) {
            // no product option
            return false
        }

        if (!isSelectableOption(o, activeOptions, product)) {
            // base not selected
            return false
        }

        return true
    })

    function colorChange(color: RALColor) {
        activeColor = color
        $contentOverlay = undefined
    }

    function optionsChange(options: string[]) {
        activeOptions = options
    }

    let ralOption: OptionEntry
    let oldProduct: Product
    $: if (oldProduct?.id != product?.id) {
        oldProduct = product
        ralOption = getProductOption(product, "ral")
    }
    $: if (ralOption) {
        if (!activeColor) {
            activeColor = colorGroup1[0]
        }
    } else {
        activeColor = undefined
    }

    let moreOptions: OptionEntry[]
    $: {
        moreOptions = product.options?.filter((o) => {
            // @ts-ignore
            if (o.option != "ral" && o.option != "installation_box_left") {
                return true
            }
        })
    }

    function openRalChooser() {
        if (ralOption) {
            $contentOverlay = {
                component: RalChooser,
                props: {
                    callback: colorChange,
                    product,
                    activeColor,
                    activeOptions,
                },
            }
        }
    }
    onMount(() => {
        $openRalChooserOverlay = openRalChooser
        $openOptionsChooserOverlay = openOptionsChooser
    })
    onDestroy(() => {
        $openRalChooserOverlay = undefined
        $openOptionsChooserOverlay = openOptionsChooser
    })

    function openOptionsChooser() {
        if (moreOptions?.length) {
            $contentOverlay = {
                component: OptionsChooser,
                props: {
                    callback: optionsChange,
                    product,
                    activeColor,
                    activeOptions,
                },
            }
        }
    }
</script>

{#if ralOption}
    <div class="infotext">
        {#if imageColorMismatch}
            {$_("product.preview-not-matching-color")}
        {/if}
    </div>
    <div class="selectbox">
        <div
            class="trigger"
            on:click="{() => {
                openRalChooser()
            }}"
        >
            <div class="label">
                <div class="option">
                    <span class="color" style="background:{activeColor?.HEX}"></span>
                    <span class="title"
                        ><span class="label_description">RAL</span>
                        {activeColor?.RAL}
                        {langField(activeColor, "")}{quboMatt}</span
                    >
                </div>
            </div>
            <div class="arrow">
                <ChevronDownIcon size="24px" />
            </div>
        </div>
    </div>
{/if}

{#if moreOptions?.length}
    <div class="selectbox">
        <div
            class="trigger"
            on:click="{() => {
                openOptionsChooser()
            }}"
        >
            <div class="label">
                <div class="option">
                    <span class="title"
                        ><span class="label_description" style="text-transform:none; font-weight:700;"
                            >{$_("product.options")}</span
                        >
                        {#each activeOptions || [] as o}
                            {optionsConf[o]?.title}<br />
                        {:else}<small>{$_("product.no-option-selected")}</small>{/each}
                    </span>
                </div>
            </div>
            <div class="arrow">
                <ChevronDownIcon size="24px" />
            </div>
        </div>
    </div>
{/if}

<style lang="less">
    @import "../../css/variables.less";
    .infotext {
        color: var(--primary);
        height: 30px;
        font-size: 0.8rem;
        line-height: 1;
    }
    .selectbox {
        margin-top: 10px;
        position: relative;
        .trigger {
            cursor: pointer;
            .flex();
            align-items: center;
            justify-content: space-between;
            border: 1px solid var(--border-color-default);
            .border-radius(5px);
            padding: 10px 10px;
            background: var(--surface);
            color: var(--on-surface);

            .arrow {
                // border-left: 1px solid var(--border-color-default);
                height: 100%;
                .flex();
                :global {
                    svg {
                        transform: rotate(-90deg);
                    }
                }
                span {
                    display: block;
                    width: 30px;
                    text-align: center;
                }
            }
            .label {
                .title {
                    font-size: 1rem !important;
                    .label_description {
                        display: block;
                        font-size: 0.7rem;
                        line-height: 1;
                        text-transform: uppercase;
                    }
                }
            }
        }
        .option {
            .flex();
            align-items: center;
            .color {
                .border-radius(5px);
                width: 30px;
                height: 30px;
                margin-right: 15px;
            }
            .title {
                line-height: 1.2;
                font-size: 1rem !important;
            }
        }
    }
</style>
